import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  #current = 0;
  autoScrollInterval;

  connectedCallback() {
    super.connectedCallback();

    const slides = this.refs.slides ?? [];
    if (!slides.length) return;

    this.addEventListener('mouseenter', this.pause);
    this.addEventListener('mouseleave', this.resume);
    document.addEventListener('visibilitychange', this.#handleVisibilityChange);

    const direction = this.getAttribute('direction') || 'left-to-right';
    const infinite = this.getAttribute('infinite') === 'true';
    const speed = parseInt(this.getAttribute('autoplay')) * 1000 || 5000;
    const wrapper = this.refs.slidesWrapper ?? slides[0].parentElement;
    if(direction === 'top-to-bottom' || direction === 'bottom-to-top'){
      wrapper.parentElement.setAttribute('vertical','true');
    } else {
      wrapper.parentElement.removeAttribute('vertical');
    }

    slides.forEach(slide => slide.setAttribute('aria-hidden','true'));
    slides[0].setAttribute('aria-hidden','false');
    if(slides.length > 1) this.startAutoScroll(direction, infinite, speed);
  }

  nextSlide(direction) {
    const slides = this.refs.slides ?? [];
    if (!slides.length) return;

    const currentSlide = slides[this.current];
    const nextIndex = (this.#current + 1) % slides.length;
    const nextSlide = slides[nextIndex];

    this.applyAnimation(currentSlide, nextSlide, direction, 'next');

    currentSlide.setAttribute('aria-hidden','true');
    nextSlide.setAttribute('aria-hidden','false');
    this.#current = nextIndex;
  }

  previousSlide(direction) {
    const slides = this.refs.slides ?? [];
    if (!slides.length) return;

    const currentSlide = slides[this.current];
    const prevIndex = (this.#current - 1 + slides.length) % slides.length;
    const prevSlide = slides[prevIndex];

    this.applyAnimation(currentSlide, prevSlide, direction, 'prev');

    currentSlide.setAttribute('aria-hidden','true');
    prevSlide.setAttribute('aria-hidden','false');
    this.#current = prevIndex;
  }

  applyAnimation(currentSlide, targetSlide, direction, type){
    // Remove all previous animation classes
    const slides = this.refs.slides ?? [];
    slides.forEach(slide => slide.classList.remove(
      'enter-left','enter-right','enter-top','enter-bottom',
      'active-left','active-right','active-top','active-bottom'
    ));

    if(type === 'next'){
      switch(direction){
        case 'left-to-right':
          targetSlide.classList.add('enter-left');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-left'); currentSlide.classList.add('enter-right'); });
          break;
        case 'right-to-left':
          targetSlide.classList.add('enter-right');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-right'); currentSlide.classList.add('enter-left'); });
          break;
        case 'top-to-bottom':
          targetSlide.classList.add('enter-top');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-top'); currentSlide.classList.add('enter-bottom'); });
          break;
        case 'bottom-to-top':
          targetSlide.classList.add('enter-bottom');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-bottom'); currentSlide.classList.add('enter-top'); });
          break;
      }
    } else { // previous
      switch(direction){
        case 'left-to-right':
          targetSlide.classList.add('enter-right');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-right'); currentSlide.classList.add('enter-left'); });
          break;
        case 'right-to-left':
          targetSlide.classList.add('enter-left');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-left'); currentSlide.classList.add('enter-right'); });
          break;
        case 'top-to-bottom':
          targetSlide.classList.add('enter-bottom');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-bottom'); currentSlide.classList.add('enter-top'); });
          break;
        case 'bottom-to-top':
          targetSlide.classList.add('enter-top');
          requestAnimationFrame(()=>{ targetSlide.classList.add('active-top'); currentSlide.classList.add('enter-bottom'); });
          break;
      }
    }
  }

  startAutoScroll(direction, infinite, speed){
    if(this.autoScrollInterval) clearInterval(this.autoScrollInterval);
    this.autoScrollInterval = setInterval(()=>{
      if(this.matches(':hover') || document.hidden) return;
      this.nextSlide(direction);
    }, speed);
  }

  pause = ()=>{ clearInterval(this.autoScrollInterval); this.autoScrollInterval=null; }
  resume = ()=>{ if(this.autoScrollInterval) return; const direction = this.getAttribute('direction') || 'left-to-right'; const speed = parseInt(this.getAttribute('autoplay'))*1000 || 5000; this.startAutoScroll(direction,true,speed); }

  get current(){ return this.#current; }
  #handleVisibilityChange = ()=> document.hidden ? this.pause() : this.resume();
}

if(!customElements.get('announcement-bar-component')){
  customElements.define('announcement-bar-component',AnnouncementBar);
}